import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './pactometro.scss';

import useResultProvider from 'dataProvider/hooks/useResultProvider';
import { useContextProperties } from 'contexts/properties';
import { useContextResultOrigin } from 'contexts/resultOrigin';
import { useContextMatchParams } from 'contexts/matchParams';

import { getPlace } from '../../dataProvider';
import { TYPES, SUBTYPES } from '../../envs';
import PactometroCheck from '../../components/pactometroCheck';
import PactometroCheckSimple from '../../components/pactometroCheck/pactometroCheckSimple';

import { useContextCurrentSite } from '../../contexts';
import { LOCALHOST, getSite } from '../../constants/sites';
import LoadingPlaceholder from '../../components/loadingPlaceholder';
import { MasterBar } from '../../components';

const Pactometro = ({ simple }) => {
  const { currentSite } = useContextCurrentSite();
  const { params } = useContextProperties();
  const resultOrigin = useContextResultOrigin();

  const { matchParams } = useContextMatchParams();
  const { year, type, electionNumber, placeId } = matchParams;

  const [place, setPlace] = useState(null);

  const site = getSite();

  getPlace({
    filter: `sortby=main&size=1&addid=${placeId}`,
    type,
    electionType: type
  }).then(_place => {
    setPlace(_place.content[0]);
  });

  const { result: dataResult } = useResultProvider({
    electionPlace: placeId,
    active: resultOrigin?.primary?.active,
    year,
    type,
    subtype: type === TYPES.GENERAL ? SUBTYPES.CONGRESS : SUBTYPES.SINGLE,
    electionNumber,
    placeId: type === TYPES.GENERAL ? 'C108' : placeId,
    site
  });

  if (!dataResult || (type !== TYPES.GENERAL && !place)) {
    return <LoadingPlaceholder />;
  }
  return (
    <div className="pagePactometro">
      <MasterBar
        optionalTitleRegular={
          params.sites[site === LOCALHOST ? currentSite : site].labels.pactos
        }
        optionalTitleStrong={`
          ${
            params.sites[site === LOCALHOST ? currentSite : site].labels
              .pactos_strong
          } ${type !== TYPES.GENERAL && place ? `- ${place.name}` : ''}`}
        isOpenedTabs={false}
      />

      {dataResult?.partiesResult &&
        dataResult.totalSeats &&
        (simple ? (
          <PactometroCheckSimple
            seatData={dataResult.partiesResult}
            totalSeat={dataResult.totalSeats}
            type={type}
          />
        ) : (
          <PactometroCheck
            seatData={dataResult.partiesResult}
            totalSeat={dataResult.totalSeats}
            type={type}
          />
        ))}
    </div>
  );
};

export default Pactometro;

Pactometro.propTypes = {
  simple: PropTypes.bool
};

Pactometro.defaultProps = {
  simple: false
};
